import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { proposedRuleAPI } from '../../utilities/api';
import { ProposedRule } from '../../utilities/interfaces/ProposedRule';

// represents the shape of the slice in state
interface proposedRuleState {
  proposedRule: ProposedRule | null;
  proposedRules: ProposedRule[];
  savingProposedRule: boolean;
}

const initialState: proposedRuleState = {
  proposedRule: null,
  proposedRules: [],
  savingProposedRule: false,
};

const proposedRuleSlice = createSlice({
  name: 'stateProposedRule',
  initialState,
  reducers: {
    // add new Agency item
    addProposedRuleItem(state, action: PayloadAction<ProposedRule>) {
      // its okay to do this because immer makes it immutable
      state.proposedRules.push(action.payload);
    },
  },
  extraReducers(builder) {
    builder.addCase(getProposedRuleByDraftId.pending, (state, action: any) => {
      state.proposedRule = null;
    });
    builder.addCase(getProposedRuleByDraftId.fulfilled, (state, action: any) => {
      // this is currently returning an array but shouldn't be only 1 proposed rule exists per draft
      state.proposedRule = action.payload[0];
    });
    builder.addCase(getAllProposedRules.fulfilled, (state, action: any) => {
      state.proposedRules = action.payload;
    });
    builder.addCase(createProposedRule.fulfilled, (state, action: any) => {
      state.proposedRule = action.payload;
      state.savingProposedRule = false;
    });
    builder.addCase(createProposedRule.pending, (state) => {
      state.savingProposedRule = true;
    });
    builder.addCase(createProposedRule.rejected, (state) => {
      state.savingProposedRule = false;
    });
    builder.addCase(updateProposedRule.fulfilled, (state, action: any) => {
      state.proposedRule = action.payload;
      state.savingProposedRule = false;
    });
    builder.addCase(updateProposedRule.pending, (state) => {
      state.savingProposedRule = true;
    });
    builder.addCase(updateProposedRule.rejected, (state) => {
      state.savingProposedRule = false;
    });
  },
});

// Async thunk to fetch data from api
// under extra reducers on fulfilled the redux store is updated
export const getProposedRuleByDraftId = createAsyncThunk(
  'stateProposedRule/getProposedRuleById',
  async (id: number) => {
    const response = await proposedRuleAPI.getProposedRuleByDraftId(id);
    return response;
  }
);

export const getAllProposedRules = createAsyncThunk(
  'stateProposedRule/getAllProposedRules',
  async () => {
    const response = await proposedRuleAPI.getAllProposedRules();
    return response;
  }
);

export const createProposedRule = createAsyncThunk(
  'state/ProposedRule/createProposedRule',
  async (proposedRule: ProposedRule) => {
    const response = await proposedRuleAPI.createProposedRule(proposedRule);
    return response;
  }
);

export const updateProposedRule = createAsyncThunk(
  'state/ProposedRule/updateProposedRule',
  async (proposedRule: ProposedRule) => {
    const response = await proposedRuleAPI.updateProposedRule(proposedRule);
    return response;
  }
);

export const { addProposedRuleItem } = proposedRuleSlice.actions;
export default proposedRuleSlice.reducer;
